var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 3.75h-1.25V3a.75.75 0 0 0-1.5 0v.75h-6.5V3a.75.75 0 0 0-1.5 0v.75H6A3.383 3.383 0 0 0 2.25 7.5V18A3.383 3.383 0 0 0 6 21.75h12A3.383 3.383 0 0 0 21.75 18V7.5A3.383 3.383 0 0 0 18 3.75zM6 5.25h1.25V6a.75.75 0 0 0 1.5 0v-.75h6.5V6a.75.75 0 0 0 1.5 0v-.75H18c1.577 0 2.25.673 2.25 2.25v.75H3.75V7.5c0-1.577.673-2.25 2.25-2.25zm12 15H6c-1.577 0-2.25-.673-2.25-2.25V9.75h16.5V18c0 1.577-.673 2.25-2.25 2.25zm-2.97-7.45a.75.75 0 0 1 0 1.061L11.7 17.2a.748.748 0 0 1-1.06 0l-1.67-1.67a.75.75 0 0 1 1.06-1.06l1.137 1.136 2.8-2.8a.749.749 0 0 1 1.063-.006z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.8380f363d4aae0d3b2522e440add2917.svg";
export { ForwardRef as ReactComponent };